import { Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { MatterAccountingSelectors } from '@state/matter/accounting/accounting.selectors';
import { Observable } from 'rxjs';
import { CosmolexAccountingItem } from '../tables/cosmolex-accounting-items-table/cosmolex-accounting-items-table.component';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterStatementofAccountSelectors } from '@state/matter/statementOfAccounts/statementOfAccounts.selectors';
import { StatementOfAccountTotals } from '@services/financialTotals/financial-totals.service';

@UntilDestroy()
@Component({
	selector: 'app-cosmolex',
	templateUrl: './cosmolex.component.html',
	standalone: false,
})
export class CosmolexComponent {
	@Select(MatterAccountingSelectors.getCosmolexNonZeroNonHstItems)
	cosmolexNonHstItems$: Observable<CosmolexAccountingItem[]>;
	@Select(MatterAccountingSelectors.getCosmolexNonZeroHstItems)
	cosmolexHstItems$: Observable<CosmolexAccountingItem[]>;
	@Select(MatterStatementofAccountSelectors.statementOfAccountsTotals)
	totals$: Observable<StatementOfAccountTotals>;

	@Select(SelectedMatter.matterHST) hst$: Observable<number>;

	constructor() {}
}
